import { render, staticRenderFns } from "./PersonalWorkPlace.vue?vue&type=template&id=79957ce8&scoped=true&"
import script from "./PersonalWorkPlace.vue?vue&type=script&lang=js&"
export * from "./PersonalWorkPlace.vue?vue&type=script&lang=js&"
import style0 from "./PersonalWorkPlace.vue?vue&type=style&index=0&id=79957ce8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79957ce8",
  null
  
)

export default component.exports